import { render, staticRenderFns } from "./report-card-small.vue?vue&type=template&id=00c618c3&scoped=true&"
import script from "./report-card-small.vue?vue&type=script&lang=js&"
export * from "./report-card-small.vue?vue&type=script&lang=js&"
import style0 from "./report-card-small.vue?vue&type=style&index=0&id=00c618c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c618c3",
  null
  
)

export default component.exports